import React, { ReactNode, createContext, useContext, useMemo } from "react";

function useProvider() {
  // eslint-disable-next-line
  const contextValue = useMemo(() => {
    return { get: "started" };
  }, []); // TODO: Add the actual context value
  return { contextValue: "GET_STARTED" };
}

const GetStartedContext = createContext<
  ReturnType<typeof useProvider>["contextValue"] | undefined
>(undefined);

const GetStartedProvider = ({ children }: { children?: ReactNode }) => {
  const { contextValue } = useProvider();
  return (
    <GetStartedContext.Provider value={contextValue}>
      {children}
    </GetStartedContext.Provider>
  );
};

export function useGetStarted() {
  const context = useContext(GetStartedContext);
  if (!context) {
    throw new Error("useGetStarted must be used within a GetStartedProvider");
  }
  return context;
}

export default GetStartedProvider;
